import React, {useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
//import "bootstrap/dist/css/bootstrap.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";
import logo from "./../../Public/img/logo-black.png";

import {successMesg, errorMesg} from "./../Toaster";
import {userRegistrationAPI} from "./../../API/AuthenticationAPI";



const Signup = () =>{

    const [username, setUsername] = useState("");
    const [uname, setUName] = useState("");
    const [uemail, setUEmail] = useState("");
    const [upassword, setUPassword] = useState("");
    const [chkterms, setChkTerms] = useState(true);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    const handleSetUName = (event) =>{
        setUName(event.target.value);
    }

    const handleSetUEmail = (event) =>{
        setUEmail(event.target.value);
    }

    const handleSetUPassword = (event) =>{
        setUPassword(event.target.value);
    }

    const handleSetTermsCondition = (event) =>{
        console.log('++++++' + event.target.checked);
        setChkTerms(event.target.checked);
    }

    const handleSetUsername = (event) =>{
        setUsername(event.target.value);
    }

    const handleSignUpSubmit = (event) =>{

        event.preventDefault();

        if(username === "")
        {
            //alert('c');
            errorMesg("Please enter your username");
        }
        else if(upassword === "")
        {
            errorMesg("Please enter your password");
        }
        else if(uname === "")
        {
            errorMesg("Please enter your name");
        }
        else if(uemail === "")
        {
            errorMesg("Please enter your email");
        }
        else if(!chkterms)
        {
            errorMesg("Please check term & conditions checkbox.");
        }
        else
        {
            const params = {
                            name:  uname,
                            password: upassword,
                            email: uemail,
                            username: username
                        };

            userRegistrationAPI(params, setLoading, navigate);
        }
    }

    return (
        <div className="account-page">
            <div className="main-wrapper">
                <div className="account-content">
                    <div className="w-100 vh-100 overflow-hidden auth-wrapper basic-auth">
                        <div className="auth-inner">
                            <div className="card__wrapper overflow-auto">
                                <form action="https://crms.dreamstechnologies.com/html/template/login.html" className="flex-fill">
                                    <div className="mx-auto mw-450">
                                        <div className="text-center mb-4 img-logo">
                                            <img src={logo} className="img-fluid" alt="Logo" />
                                        </div>
                                        <div className="mb-4 text-center">
                                            <h4 className="mb-2 fs-20">Create an account</h4>                                            
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Username</label>
                                            <div className="position-relative">
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-user"></i>
                                                </span>
                                                <input type="text" name="username" id="username" value={username} className="form-control" onChange={handleSetUsername} />
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Password</label>
                                            <div className="pass-group">
                                                <input type="password" name="upasswd" id="upasswd" value={upassword} className="pass-input form-control" onChange={handleSetUPassword} />
                                                <span className="ti toggle-password ti-eye-off"></span>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Name</label>
                                            <div className="position-relative">
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-user"></i>
                                                </span>
                                                <input type="text" name="uname" id="uname" value={uname} className="form-control" onChange={handleSetUName} />
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Email </label>
                                            <div className="position-relative">
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-mail"></i>
                                                </span>
                                                <input type="email" name="uemail" id="uemail" value={uemail} className="form-control" onChange={handleSetUEmail} />
                                            </div>
                                        </div>
                                        
                                        {/*<div className="mb-3">
                                            <label className="col-form-label">Confirm Password</label>
                                            <div className="pass-group">
                                                <input type="password" className="pass-inputs form-control" />
                                                <span className="ti toggle-passwords ti-eye-off"></span>
                                            </div>
                                        </div>*/}
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <div className="form-check form-check-md d-flex align-items-center">
                                                <input className="form-check-input" type="checkbox" id="checkebox-md"
                                                    checked={chkterms} onChange={handleSetTermsCondition} />
                                                <label className="form-check-label" for="checkebox-md">
                                                    I agree to the <Link to="javascript:void(0);" className="text-primary link-hover">Terms & Privacy</Link>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            
                                            <button type="button" className="btn btn-primary w-100"  onClick={handleSignUpSubmit}>
                                                {loading ?
                                                    <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                :
                                                    <p>Sign Up</p>
                                                }
                                            </button>
                                        </div>
                                        <div className="mb-3 text-center">
                                            <h6>Already have an account? <Link to="/sign-in"  className="text-purple link-hover">Sign in here</Link>
                                            </h6>
                                        </div>
                                        {/*<div className="form-set-login or-text mb-3">
                                            <h4>OR</h4>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center flex-wrap mb-3">
                                            <div className="text-center me-2 flex-fill">
                                                <a href="javascript:void(0);"
                                                    className="br-10 p-2 px-4 btn bg-pending  d-flex align-items-center justify-content-center">
                                                    <img className="img-fluid m-1" src="assets/img/icons/facebook-logo.svg"
                                                        alt="Facebook" />
                                                </a>
                                            </div>
                                            <div className="text-center me-2 flex-fill">
                                                <a href="javascript:void(0);"
                                                    className="br-10 p-2 px-4 btn bg-white d-flex align-items-center justify-content-center">
                                                    <img className="img-fluid  m-1" src="assets/img/icons/google-logo.svg"
                                                        alt="Facebook" />
                                                </a>
                                            </div>
                                            <div className="text-center flex-fill">
                                                <a href="javascript:void(0);"
                                                    className="bg-dark br-10 p-2 px-4 btn btn-dark d-flex align-items-center justify-content-center">
                                                    <img className="img-fluid  m-1" src="assets/img/icons/apple-logo.svg" alt="Apple" />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <p className="fw-medium text-gray">Copyright &copy; 2024 - CRMS</p>
                                        </div>*/}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <ToastContainer />

            </div>
        </div>
    )
}

export default Signup;